<template>
  <div id="series-graph">
    <Plotly
      :data="dataset || row"
      :layout="layout"
      :display-mode-bar="true"
      :displaylogo="false"
      :scroll-zoom="true"
      @click="$emit('update-offset', $event)"
    ></Plotly>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import { mapGetters } from "vuex";

export default {
  name: "SeriesGraph",
  components: { Plotly },
  props: {
    title: { type: String, default: () => "" },
    height: { type: Number, default: () => 600 },
    yaxisUnit: { type: String, default: () => "&mu;ε" },
    dataset: { type: Array },
    shapes: { type: Array, default: () => [] },
  },
  computed: {
    ...mapGetters("series", { row: "data" }),
  },
  data() {
    return {
      layout: {
        title: this.title,
        height: this.height,
        margin: {
          t: 30,
          b: 30,
          l: 50,
          r: 50,
        },
        dragmode: "pan",
        xaxis: {
          type: "date",
        },
        yaxis: {
          type: "linear",
          ticksuffix: this.yaxisUnit,
        },
        yaxis2: {
          type: "linear",
          overlaying: "y",
          side: "right",
          ticksuffix: "&deg;C",
        },
        shapes: this.shapes,
      },
    };
  },
};
</script>

<style></style>
